/**
 * Unified multi-script font stack for the whole Market platform.
 *
 * The browser resolves the font per-character, so Latin text renders with Inter
 * while each non-Latin script falls back to the matching Noto Sans face. Loaded
 * in `index.html` so Help and app UI share identical typography.
 */
export const APP_FONT_FAMILY = [
  '"Inter"',
  '"Noto Sans Arabic"',
  '"Noto Sans Devanagari"',
  '"Noto Sans Bengali"',
  '"Noto Sans Sinhala"',
  '"Helvetica"',
  '"Arial"',
  'sans-serif',
].join(', ');
